import clsx from 'clsx';
import type { InputHTMLAttributes, ReactNode } from 'react';

/**
 * Campo de texto da tela de login. Não é o `Entrada`/`Campo` de
 * `componentes/ui.tsx`: aqueles usam `tinta-*`/`marca-*`, que INVERTEM entre
 * os temas — esta superfície é fixa (`auth-*`), então precisa da própria
 * primitiva. Ver o comentário de `--color-auth-fundo-1` em `estilos.css`.
 *
 * `trailing` é o slot do botão de olho do campo de senha (`LoginForm`): fica
 * posicionado sobre o campo, e quem chama continua responsável pelo próprio
 * rótulo acessível do botão — este componente só reserva o espaço (`pr-11`
 * fica a cargo de quem passa `className`, porque só o campo de senha precisa).
 */
interface TextFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  id: string;
  rotulo: string;
  trailing?: ReactNode;
}

export function TextField({ id, rotulo, trailing, className, ...resto }: TextFieldProps) {
  return (
    <div className="flex flex-col gap-1.5">
      <label htmlFor={id} className="text-auth-texto-secundario text-sm font-medium">
        {rotulo}
      </label>
      <div className="relative">
        <input
          id={id}
          className={clsx(
            'h-11 w-full rounded-auth-controle border border-auth-borda/10 bg-auth-superficie/4',
            'text-auth-texto placeholder:text-auth-texto-terciario px-3 text-sm',
            'transition-[transform,opacity,box-shadow] duration-300 ease-out',
            'focus:border-auth-marca-hover focus:ring-auth-marca-hover/35 focus:outline-none focus:ring-2',
            className,
          )}
          {...resto}
        />
        {trailing}
      </div>
    </div>
  );
}
